import api from './api';

export interface Project {
  id: number;
  title: string;
  description?: string;
  category: string;
  status: string;
  visibility: string;
  owner_id: number;
  owner_name?: string;
  agent_count?: number;
  task_count?: number;
  members_count?: number;
  agents_count?: number;
  tasks_count?: number;
  findings_count?: number;
  is_featured?: number;
  created_at: string;
  updated_at: string;
  project_type?: 'research' | 'mission';
}

export interface ProjectDetail extends Project {
  agents: Array<{
    id: number;
    agent_id: number;
    agent_name: string;
    persona?: string;
    expertise?: string;
    role: string;
    status: string;
  }>;
  tasks: Array<{
    id: number;
    title: string;
    description?: string;
    status: string;
    priority: string;
    assigned_to?: number;
    assigned_agent_name?: string;
    created_at: string;
  }>;
}

export interface ProjectCreate {
  title: string;
  description?: string;
  category: string;
  visibility?: string;
  agent_ids: number[];
}

export interface TaskCreate {
  title: string;
  description?: string;
  priority?: string;
  assigned_to?: number;
}

export const projectsApi = {
  // Projects
  async getProjects(status?: string, projectType?: string) {
    const params = new URLSearchParams();
    if (status) {params.append('status', status);}
    if (projectType) {params.append('project_type', projectType);}

    const response = await api.get(`/projects?${params.toString()}`);
    return response.data;
  },

  async getProject(id: number): Promise<ProjectDetail> {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  async createProject(data: ProjectCreate) {
    const response = await api.post('/projects', data);
    return response.data;
  },

  async updateProject(id: number, data: Partial<ProjectCreate>) {
    const response = await api.put(`/projects/${id}`, data);
    return response.data;
  },

  async deleteProject(id: number) {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },

  // Tasks
  async getTasks(projectId: number) {
    const response = await api.get(`/projects/${projectId}/tasks`);
    return response.data;
  },

  async createTask(projectId: number, data: TaskCreate) {
    const response = await api.post(`/projects/${projectId}/tasks`, data);
    return response.data;
  },

  async updateTask(taskId: number, data: { status?: string; assigned_to?: number }) {
    const response = await api.put(`/tasks/${taskId}`, data);
    return response.data;
  },

  // Agents
  async assignAgent(projectId: number, agentId: number) {
    const response = await api.post(`/projects/${projectId}/agents/${agentId}`);
    return response.data;
  },

  async removeAgent(projectId: number, agentId: number) {
    const response = await api.delete(`/projects/${projectId}/agents/${agentId}`);
    return response.data;
  },
};

export default projectsApi;
